const { default: endOfDayHistory } = await import(`./V1/endOfDayHistory.json`, { with: { type: 'json' } });
const { default: streamingMarketData } = await import(`./V1/streamingMarketData.json`, { with: { type: 'json' } });
const { default: intradayHistory } = await import(`./V1/intradayHistory.json`, { with: { type: 'json' } });
const { default: intradaySnapshot } = await import(`./V1/intradaySnapshot.json`, { with: { type: 'json' } });
const { default: entityBase } = await import(`./V1/entityBase.json`, { with: { type: 'json' } });
const { default: marketBase } = await import(`./V1/marketBase.json`, { with: { type: 'json' } });
const { default: listingBase } = await import(`./V1/listingBase.json`, { with: { type: 'json' } });
const { default: instrumentBase } = await import(`./V1/instrumentBase.json`, { with: { type: 'json' } });
const { default: instrumentSymbology } = await import(`./V1/instrumentSymbology.json`, { with: { type: 'json' } });
const { default: listingSymbology } = await import(`./V1/listingSymbology.json`, { with: { type: 'json' } });
const { default: freeTextSearch } = await import(`./V1/freeTextSearch.json`, { with: { type: 'json' } });
const { default: endOfDaySnapshot } = await import(`./V1/endOfDaySnapshot.json`, { with: { type: 'json' } });
const { default: instrumentMarkets } = await import(`./V1/instrumentMarkets.json`, { with: { type: 'json' } });
const { default: streamingIntradayTradesWithHistory } = await import(`./V1/streamingIntradayTradesWithHistory.json`, { with: { type: 'json' } });
const { default: fundamentals } = await import(`./V1/fundamentals.json`, { with: { type: 'json' } });
const { default: estimates } = await import(`./V1/estimates.json`, { with: { type: 'json' } });
const { default: indexComposition } = await import(`./V1/indexComposition.json`, { with: { type: 'json' } });
const { default: entityClassification } = await import(`./V1/entityClassification.json`, { with: { type: 'json' } });
const { default: instrumentClassification } = await import(`./V1/instrumentClassification.json`, { with: { type: 'json' } });
const { default: corporateActions } = await import(`./V1/corporateActions.json`, { with: { type: 'json' } });
const { default: fixedIncomeReferenceDataExtended } = await import(`./V1/fixedIncomeReferenceDataExtended.json`, { with: { type: 'json' } });
const { default: digitalAssetsRegulatoryAndTaxServices } = await import(`./V1/digitalAssetsRegulatoryAndTaxServices.json`, { with: { type: 'json' } });

export const apisv1 = {
    endOfDayHistory,
    streamingMarketData,
    intradayHistory,
    intradaySnapshot,
    entityBase,
    marketBase,
    listingBase,
    instrumentBase,
    instrumentSymbology,
    listingSymbology,
    freeTextSearch,
    endOfDaySnapshot,
    instrumentMarkets,
    streamingIntradayTradesWithHistory,
    estimates,
    fundamentals,
    indexComposition,
    entityClassification,
    instrumentClassification,
    corporateActions,
    fixedIncomeReferenceDataExtended,
    digitalAssetsRegulatoryAndTaxServices
}
